import { clientEnv } from "config"
import LogRocket from "logrocket"

function isHeadlessBrowser(): boolean {
  return (
    typeof navigator !== 'undefined' && (navigator.webdriver || navigator.userAgent.includes('HeadlessChrome'))
  )
}

if (clientEnv.isProduction && typeof window !== undefined && !isHeadlessBrowser()) {
  LogRocket.init("we7skf/homeschool-boss")
}

export default LogRocket
